import { SkeletonPage } from "@/components/SkeletonLoaders.jsx";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SkeletonPage />}>
    <Component {...props} />
  </Suspense>
);

const SportsListPage = Loadable(
  lazy(() => import("./pages/SportsListPage"))
);
const SportsGroundListing = Loadable(
  lazy(() => import("./SportsGroundListing/index.jsx"))
);
const SportsDetail = Loadable(lazy(() => import("./SportsDetail/index.jsx")));
const SportsSlotBook = Loadable(
  lazy(() => import("./pages/SportsSlotBook"))
);
const BookingSummary = Loadable(
  lazy(() => import("./BookingSummary/index.jsx"))
);
const SportsSelect = Loadable(lazy(() => import("./SportsSelect/index.jsx")));
const GroundBookingConfirm = Loadable(
  lazy(() => import("./GroundBookingConfirm/index.jsx"))
);
const SportsPlay = Loadable(lazy(() => import("./pages/SportsPlay.jsx")));
const CreatGame = Loadable(lazy(() => import("./pages/SportsCreateGame.jsx")));
const SportsJoinGame = Loadable(lazy(() => import("./pages/SportsJoinGame.jsx")));
const SportsMyGames = Loadable(lazy(() => import("./pages/SportsMyGames.jsx")));



const sportsRoutes = [
  {
    path: "sports",
    children: [
      {
        index: true,
        element: <Navigate to="9" replace />,
      },
      {
        path: ":category_id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsListPage />
          </Suspense>
        ),
      },
      {
        path: "ground-listing/:category_id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsGroundListing />
          </Suspense>
        ),
      },
      {
        path: "provider-detail/:provider_id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsDetail />
          </Suspense>
        ),
      },
      {
        path: "slot-book",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsSlotBook />
          </Suspense>
        ),
      },
      {
        path: "booking-summary",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <BookingSummary />
          </Suspense>
        ),
      },
      {
        path: "service-select",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsSelect />
          </Suspense>
        ),
      },
      {
        path: "booking-confirm",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <GroundBookingConfirm />
          </Suspense>
        ),
      },
      {
        path: "play",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsPlay />
          </Suspense>
        )
      },
      {
        path: "create-game",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <CreatGame />
          </Suspense>
        )
      },
      {
        path: "join-game/:id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsJoinGame />
          </Suspense>
        )
      },
      {
        path: "my-games",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SportsMyGames />
          </Suspense>
        )
      }
    ],
  },
];

export default sportsRoutes;

